



















































/* General */
import Vue from 'vue'
import MailboxSettingsLayout from '@/layouts/mailbox-settings-layout.vue'

/* Mixins */

/* Components */
import EntitySettingsLoading from '@/layouts/entity-settings-loading.vue'
import MailboxSettingsAutoForwardingEmail from './components/mailbox-settings-auto-forwarding-email.vue'

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'

/* Data types */

/* API */
import MailboxesAPI from '@/api/modules/mailboxes.api'

export default Vue.extend({
  name: 'MailboxSetupAutoForwarding',

  metaInfo(): any {
    return {
      title: `Auto-Forwarding - ${this.name}`,
    }
  },

  components: {
    MailboxSettingsLayout,
    MailboxSettingsAutoForwardingEmail,
    EntitySettingsLoading,
  },

  data() {
    return {
      RouteAssistant,
      isLoading: true,
      name: '',
      incomingEmailAddress: '',
      forwardingEmailAddresses: [] as string[],
    }
  },

  computed: {
    accountID(): number {
      return parseInt(this.$route.params.accountId, 10)
    },
    id(): number {
      return parseInt(this.$route.params.id, 10)
    },
    hasForwardingEmailAddresses(): boolean {
      return this.forwardingEmailAddresses.length > 0
    },
  },

  async created() {
    this.isLoading = true
    await this.getAutoForwardingInfo()
    this.isLoading = false
  },

  methods: {
    async getAutoForwardingInfo() {
      try {
        const response = await MailboxesAPI.get_AutoForwarding(this.id)
        this.name = response.name
        this.incomingEmailAddress = response.incomingEmailAddress
        this.forwardingEmailAddresses = response.listForwardingEmailAddresses
      } catch (error) {
        this.$error.emit(error)
      }
    },
    goToAutoForwardingSetup() {
      // Auto-route to auto-forwarding setup...
      RouteAssistant.goToMailboxVerificationIntroRoute(
        this.$router,
        this.accountID,
        this.id,
      )
    },
    async confirmRemoveEmailAddress(email: string) {
      this.$confirm(
        `Removing ${email} from this list does not disable auto-forwarding. You will
        also need to remove the auto-forwarding rule from your email provider.`,
        'Warning!',
        {
          confirmButtonText: 'I understand, remove this email.',
          cancelButtonText: 'Cancel',
          confirmButtonClass: 'el-button--strawberry',
          type: 'warning',
          center: true,
        },
      ).then(() => {
        this.forwardingEmailAddresses = this.forwardingEmailAddresses.filter(
          e => e !== email,
        )
        this.updateForwardingEmailAddresses()
      })
    },
    confirmNewIncomingEmailAddress() {
      this.$confirm(
        'Once you generate a new forwarding address, the old one will no longer work and existing auto-forwarding rules need to be updated. Are you sure?',
        'Warning!',
        {
          confirmButtonText: 'Yes, generate a new address',
          cancelButtonText: 'No, take me back',
          confirmButtonClass: 'el-button--strawberry',
          type: 'warning',
          center: true,
        },
      ).then(() => {
        this.generateIncomingEmailAddress()
      })
    },
    async generateIncomingEmailAddress(): Promise<void> {
      try {
        const response = await MailboxesAPI.get_GenerateIncomingEmailAddress(
          this.id,
        )
        this.incomingEmailAddress = response.incomingEmailAddress
        this.$messaging.showSuccess(
          'A new forwarding address has been created!',
        )
      } catch (err) {
        this.$error.emit(err, true)
        await this.getAutoForwardingInfo()
      }
    },
    async updateForwardingEmailAddresses(): Promise<void> {
      try {
        const response = await MailboxesAPI.post_AutoForwarding(
          this.id,
          this.forwardingEmailAddresses,
        )
        this.$messaging.showSuccess(response.message)
      } catch (err) {
        this.$error.emit(err, true)
        await this.getAutoForwardingInfo()
      }
    },
  },
})
